import { render, staticRenderFns } from "./dialog-list.vue?vue&type=template&id=8b3cbeb6&scoped=true&"
import script from "./dialog-list.vue?vue&type=script&lang=js&"
export * from "./dialog-list.vue?vue&type=script&lang=js&"
import style0 from "./dialog-list.vue?vue&type=style&index=0&id=8b3cbeb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3cbeb6",
  null
  
)

export default component.exports